import React from 'react'
import Group from 'components/utils/Group'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

interface Props {
  hideSelect?: boolean;
}

const LesaOfferCardContainer = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border: 1px solid ${({ theme }) => theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.M};
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(4)};
  padding: ${rem(20)};
  overflow: hidden;
  min-height: ${rem(170)};
  max-width: ${rem(440)};
  width: 100%;

  ${mediaQueryUp.tablet} {
    width: ${rem(440)};
  }

  ${mediaQueryUp.desktop} {
    grid-template-columns: 1fr ${rem(80)};
    grid-template-rows: min-content min-content;
  }
`

const LesaOfferCardHeader = styled(Group)`
  ${mediaQueryUp.desktop} {
    grid-column: span 3;
  }
`

function LesaPurchaseSummarySkeleton({ hideSelect }: Props) {
  return (
    <LesaOfferCardContainer>
      <LesaOfferCardHeader direction="horizontal" horizontalAlign="space-between" verticalAlign="start">
        <LoadingBox style={{ width: 160, height: 16 }}/>
        {!hideSelect && <LoadingBox style={{ width: 60, height: 24 }}/>}
      </LesaOfferCardHeader>
      <Group direction="vertical">
        <Group direction="vertical" gap={4}>
          <LoadingBox style={{ width: 100, height: 14 }}/>
          <LoadingBox style={{ width: '100%', height: 20 }}/>
          <LoadingBox style={{ width: '90%', height: 20 }}/>
          <LoadingBox style={{ width: 140, height: 16 }}/>
          <LoadingBox style={{ width: 120, height: 16 }}/>
        </Group>
      </Group>
      {!hideSelect && <Group fullWidth direction="horizontal" horizontalAlign="end" verticalAlign="end">
        <LoadingBox style={{ width: 80, height: 32 }}/>
      </Group>}
    </LesaOfferCardContainer>
  )
}

export default LesaPurchaseSummarySkeleton
